import React from 'react';

import { MODAL_TYPES } from 'Feature/components/app-modals';
import WorkTicketAddEdit from './work-ticket-add-edit';

const { WORKTICKET_ADD_EDIT } = MODAL_TYPES;

const WorkTicketModals = () => {
  return (
      <>
         <WorkTicketAddEdit modalId={WORKTICKET_ADD_EDIT} />
        
       </>
     );
   };
   

export default WorkTicketModals